<template>
  <v-card class="pr-4 pl-4 pr-md-12 pl-md-12">
    <v-card-title primary-title>
      <div class="text-h4">
        Helgspärr         
      </div>
      <v-spacer />         
    </v-card-title>   
    <v-card-text>
      <template v-for="holiday in holidaysList">
        <Holiday :key="holiday.day" :holiday="holiday" />                  
      </template>
    </v-card-text>
   
    <v-card-text>
      <v-card-title>
        Tidigare rapporterat
      </v-card-title>
      <v-row>
        <v-col cols="12" md="6">
          <v-simple-table fixed-header class="md-col-5">
            <template v-slot:default>
              <thead align="left">
                <tr>
                  <th>
                    Datum
                  </th>
                  <th>
                    Beskrivning
                  </th>
                  <th>
                    Status
                  </th>                
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(holiday) in historicHolidaysList"
                  :key="holiday.day"
                >
                  <td>{{ holiday.day | toLocalDate }}</td>
                  <td>{{ holiday.description }}</td>
                  <td>              
                    {{ holiday.open?'Öppet':'Stängt' }}                
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>  
</template>

<script>
import log from '@/logger'
import api from '@/backend/api'
import Holiday from '@/components/web/Holiday'
import { orderBy} from 'lodash'

export default {
  name:'HolidayView',
  components:{Holiday},
   data(){
    return {
      holidays:[]
    }
  },
  computed:{
    holidaysList(){
      return this.holidays.filter(h=>h.deleted === false)
    },
    historicHolidaysList(){
      return  orderBy(this.holidays.filter(h=>h.deleted === true || h.open !== null),['day'],['desc'])
    },
   
  },
  mounted(){
    api.getHolidays(true).then(resp => {
      log.debug('Got holidays ', resp.data)
        this.holidays = resp.data
      })
  },
  methods: {
    openOrClosed(holiday){
          return holiday.open?'Öppet':'Stängt'
    }  
  }
}
</script>
